import { Component, OnInit, Input } from '@angular/core';
import { Parent } from '../../../../../models/parent';
import { PrifactRoute } from '../../../../../models/prifact-route';
import { RoutingService } from '../../../../../services/routing-service/routing.service';
import { Device } from '@ionic-native/device/ngx';
import { FileService } from 'src/app/services/file-service/file.service';
import { flatMap } from 'rxjs/operators';
import { StudentProfileService } from '../../services/student-profile.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {

  constructor(private routingService: RoutingService
    , public device: Device
    , private fileService: FileService
    , private studentProfileService: StudentProfileService) { }


  @Input() userInfo: Parent
  @Input() editable: boolean
  selectedFile: File;
  showFileSelector: boolean;
  showImage: boolean = true;
  force_reload: boolean = false;
  errorMessage: string = null;
  
  ngOnInit() {
  }

  onProfileEdit() {
    let route = new PrifactRoute();
    route.primary_command = ['pages', 'my-account-edit'];
    route.append_current_url_to_history = true;
    this.routingService.navigate(route);
  }

  onChangeProfilePhoto() {
    this.showFileSelector = true;
  }

  onFileSelect(files: Array<File>) {
    this.showImage = false;
    this.showFileSelector = false;
    this.selectedFile = files[0];
    this.fileService.uploadFile(this.selectedFile).pipe(
      flatMap(res => {
        if (res.message) {
          this.errorMessage = res.message;
          setTimeout(() => {
            this.errorMessage = null;
          }, 3000);
        }
        else {
          return this.studentProfileService.updateProfilePhoto(this.userInfo.person_id, 2, res);
        }
      })
    )
      .subscribe(res => {
        this.force_reload = true;
        this.showImage = true;
      });
  }

} 
